import Vue from "vue";
import Vuex from "vuex";
import Roles from "./Roles";
import Users from "./Users";
import Teams from "./Teams";
import Testimonials from "./Testimonials";
import Blogs from "./Blogs";
import Forums from "./Forums";
import Country from "./Country";
import Membership from "./Membership";
import Announcements from "./Announcements";
import Coupon from "./Coupon";
import EventAndGroup from "./EventAndStudy";
import Newsletter from "./Newsletter";
import Polls from "./Polls";
import Courses from "./Courses";
import DigitalManual from "./DigitalManual";
import DownloadFiles from "./DownloadFiles";
import Seminar from "./Seminar";
import Currency from "./Currency";
import Store from "./Store";
import Videos from "./Videos";
import Sales from "./Sales";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Roles,
    Users,
    Teams,
    Testimonials,
    Blogs,
    Forums,
    Membership,
    Announcements,
    Country,
    Coupon,
    EventAndGroup,
    Newsletter,
    Polls,
    Courses,
    DigitalManual,
    DownloadFiles,
    Seminar,
    Currency,
    Store,
    Videos,
    Sales,
  },
  state: {},
  mutations: {},
  actions: {},
  plugins: [],
});
